$('.header-carousel').slick({
  dots: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 5000,
  nextArrow: '.slick-arrow.next',
  prevArrow: '.slick-arrow.prev',
  pauseOnFocus: false,
  pauseOnHover: false
});

$('.prev').on('click', () => {
   $('.next').removeClass('run-animation');
})

// retrieve the element
let elementNext = document.getElementById("next");
if (elementNext != undefined) {
  // reset the transition by...
  elementNext.addEventListener("click", function(e) {
    e.preventDefault;
    
    // -> removing the class
    elementNext.classList.remove("run-animation");
    
    // -> triggering reflow /* The actual magic */
    // without this it wouldn't work. Try uncommenting the line and the transition won't be retriggered.
    // Oops! This won't work in strict mode. Thanks Felis Phasma!
    // element.offsetWidth = element.offsetWidth;
    // Do this instead:
    void elementNext.offsetWidth;
    
    // -> and re-adding the class
    elementNext.classList.add("run-animation");
  }, false);
}

const offcanvasSearch = document.getElementById('offcanvasSearch')
if (offcanvasSearch != undefined) {
  offcanvasSearch.addEventListener('shown.bs.offcanvas', event => {
    document.getElementById("Search").focus();
  })
}